import { CopyIcon } from "@chakra-ui/icons";
import { IconButton, useToast } from "@chakra-ui/react";
import { useIntl } from "react-intl";

export const CopyButton = ({
  copyText,
  title,
  toastMessage,
  boxSize,
}: {
  copyText: string;
  title: string;
  toastMessage: string;
  boxSize?: string;
}) => {
  const intl = useIntl();
  const toast = useToast();

  const handleCopy = () => {
    navigator.clipboard.writeText(copyText);
    toast({
      title: intl.formatMessage({
        id: "copied",
        defaultMessage: "Copied!",
      }),
      description: toastMessage,
    });
  };

  return (
    <IconButton
      aria-label={title}
      title={title}
      variant="primary"
      flexShrink={0}
      ml={2}
      minW={0}
      boxSize={boxSize ?? "button"}
      p={0}
      onClick={handleCopy}
    >
      <CopyIcon />
    </IconButton>
  );
};
